"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Medication = require("./Medication");
Object.keys(_Medication).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Medication[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Medication[key];
    }
  });
});